import React from 'react';
import { StudyPlanWizard } from '../../components/study-plan';

const StudyPlan: React.FC = () => {
  return (
    <div className="study-plan-page">
      <StudyPlanWizard />
    </div>
  );
};

export default StudyPlan;